import { IdNameItem } from "@/dto/responses/id.name.response";
import userStore from "@/stores/user.store";
import { FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./user.group.select.css";
import { FilterProfilesRequest } from "@/models/user";

interface IUserProfileSelect {
    value?: number | null;
    width?: string;
    updateProfile: (arg: number) => void;
    required?: boolean | undefined;
}

const UserProfileSelect: FC<IUserProfileSelect> = (props: IUserProfileSelect) => {
    const [profileOptions, setProfileOptions] = useState<IdNameItem[]>([]);
    const { t } = useTranslation();
    const init = async () => {
        await userStore.getUserProfiles(new FilterProfilesRequest());
        setProfileOptions(userStore.userProfiles);
    };
    useEffect(() => {
        init();
    }, []);
    return (
        <FormControl size="small">
            <InputLabel required id="select-user-group-label">
                {t("user.Profile")}
            </InputLabel>
            <Select
                id="user-select-group-label"
                labelId="select-user-group-label"
                className="select-user-group"
                label={t("user.Profile")}
                sx={{ width: props.width ?? "100%" }}
                onChange={(event: SelectChangeEvent) => props.updateProfile(parseInt(event.target.value))}
                value={props.value ? props.value?.toString() : ""}
                required={props.required}
            >
                {profileOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default UserProfileSelect;
